export function formatTimeGMT5(time,offset) {
  if (!time) return '';
  const [hh, mm] = time.split(':');
  let calculo = Number(hh) + offset;
  if (calculo < 0) calculo += 24;
  const hhStr = calculo.toString().padStart(2, '0');
  return `${hhStr}:${mm}`;
}